module.exports = __webpack_public_path__ + "static/media/unterweisung_true_active.224bc87a.jpg";